import { render, staticRenderFns } from "./PlanProfileNewPage.vue?vue&type=template&id=fda950a0&scoped=true&"
import script from "./PlanProfileNewPage.vue?vue&type=script&lang=js&"
export * from "./PlanProfileNewPage.vue?vue&type=script&lang=js&"
import style0 from "./PlanProfileNewPage.vue?vue&type=style&index=0&id=fda950a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda950a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VRow,VSkeletonLoader})
